import React from 'react';

export const Facebook = React.memo(({ fill }) => (
  <>
    <path
      d='M40 20.1217C40 9.00609 31.0484 0 20 0C8.95161 0 0 9.00609 0 20.1217C0 30.1647 7.31371 38.4893 16.875 40V25.9383H11.7944V20.1217H16.875V15.6884C16.875 10.6458 19.8589 7.86045 24.429 7.86045C26.6177 7.86045 28.9065 8.25314 28.9065 8.25314V13.2024H26.3839C23.9 13.2024 23.125 14.7538 23.125 16.3448V20.1217H28.6718L27.7847 25.9383H23.125V40C32.6863 38.4893 40 30.1647 40 20.1217Z'
      fill={fill}
    />
  </>
));
Facebook.displayName = 'Facebook';
